module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/page-2.json
// module id = 320
// module chunks = 135728916539164